"use client";

import PhoneAuthForm, { AuthFooterLink } from '@/components/auth/PhoneAuthForm';

export default function LoginContent() {
  return (
    <PhoneAuthForm
      mode="login"
      title="Welcome Back"
      subtitle="Sign in with your mobile number"
      submitLabel="Send code"
      footer={
        <AuthFooterLink href="/register" prompt="New to CardBox?" action="Create an account" />
      }
    />
  );
}
